import { Suspense, lazy } from 'react';
import { Center, Spinner } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { FullScreenRouteModal } from '../layout/FullScreenRouteModal';
import { isScanModalPresentation } from '../../scan/scanModalNavigation';

const CollectionScanPage = lazy(() =>
  import('../../views/CollectionScanPage').then((m) => ({ default: m.CollectionScanPage })),
);

function ScanModalLoader() {
  return (
    <Center flex="1" bg="black">
      <Spinner color="accent" />
    </Center>
  );
}

/**
 * FullScreen scan cover mounted next to the underlay shell (under ModalProvider).
 * Kept out of AppLayout so transform/overflow ancestors cannot trap `position: fixed`.
 */
export function CollectionScanModalLayer() {
  const location = useLocation();
  const open = isScanModalPresentation(location);

  return (
    <FullScreenRouteModal open={open} label="Scan cards">
      <Suspense fallback={<ScanModalLoader />}>
        <CollectionScanPage />
      </Suspense>
    </FullScreenRouteModal>
  );
}
